import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { DraftOfferDesktop } from '../components/draft-offer/desktop';
import type { IDeps, TDcDraft } from '../models';
import { DcDraft as Component } from '../dc-draft';

export const DcDraftDesktop = createWidget<IDeps, TDcDraft>({
    DraftOffer: DraftOfferDesktop,
})(Component);
